import React, { SVGProps } from 'react';

const Empty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="128"
    height="127"
    viewBox="0 0 128 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M128 127H0V0.000205994H128V127Z" fill="white" />
    <mask
      id="mask0_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="15"
      width="96"
      height="95"
    >
      <path
        d="M56.9535 109.557C55.4527 109.557 53.9746 109.498 52.5238 109.38C47.0602 108.937 36.0677 108.046 27.4847 100.093C16.4714 89.8877 13.9497 72.2498 18.1957 56.0602C18.72 57.6513 19.3773 59.2307 20.1902 60.7903C20.3751 61.145 20.5679 61.4883 20.768 61.8221C20.7562 62.2449 20.7503 62.6707 20.7503 63.0965C20.7503 88.0087 41.1049 108.204 66.2133 108.204C67.6799 108.204 69.1283 108.136 70.5594 108.001C65.9818 109.043 61.3765 109.557 56.9535 109.557ZM111.674 62.5892C111.401 37.9098 91.1519 17.9883 66.2133 17.9883C55.2101 17.9883 45.1212 21.8657 37.2566 28.3201C37.2321 27.7293 37.1949 27.1549 37.1476 26.5996C43.6632 21.4607 53.8766 15.6756 66.8992 15.6756C67.0441 15.6756 67.189 15.6762 67.3349 15.6776C83.3822 15.8368 94.6458 24.7186 96.0155 25.8253C97.7454 27.223 101.562 30.5448 105.001 35.8145C110.025 43.5125 112.2 53.1057 111.674 62.5892Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_514_140551)">
      <path
        d="M56.9535 109.557C55.4527 109.557 53.9746 109.498 52.5239 109.38C47.0602 108.937 36.0677 108.046 27.4847 100.093C16.4714 89.8877 13.9497 72.2498 18.1957 56.0598C18.72 57.6512 19.3773 59.2307 20.1902 60.7903C20.375 61.1449 20.5679 61.4883 20.768 61.822C20.7562 62.2448 20.7503 62.6707 20.7503 63.0965C20.7503 88.0088 41.1049 108.204 66.2133 108.204C67.68 108.204 69.1286 108.136 70.5597 108.001C65.9818 109.043 61.3765 109.557 56.9535 109.557ZM111.674 62.5892C111.401 37.9098 91.1518 17.988 66.2133 17.988C55.2101 17.988 45.1213 21.8653 37.2566 28.3201C37.2321 27.7293 37.1949 27.1549 37.1476 26.5997C43.6632 21.4603 53.8767 15.6755 66.8992 15.6755C67.0441 15.6755 67.189 15.6762 67.335 15.6775C83.3823 15.8367 94.6458 24.7188 96.0157 25.8252C97.7455 27.2232 101.562 30.5445 105.001 35.8144C110.025 43.5122 112.2 53.1053 111.674 62.5892Z"
        fill="url(#paint0_linear_514_140551)"
      />
    </g>
    <path
      d="M20.8576 16.034C20.8193 15.6432 21.3905 15.4633 21.6833 15.7719C24.6574 18.9045 31.5874 28.021 27.6795 41.8111C22.7764 59.1137 26.191 66.1226 30.996 70.7617C30.996 70.7617 23.9159 67.9359 20.1903 60.789C11.0432 43.2412 21.5376 22.9807 20.8576 16.034Z"
      fill="#BDD0FB"
    />
    <path
      d="M21.0332 58.041C20.4601 56.0405 20.3135 53.9721 20.4414 51.958C20.5598 50.0614 20.8833 48.2035 21.2088 46.3592C20.672 49.9904 20.9749 53.151 21.4102 55.3988C21.259 56.2716 21.1331 57.1521 21.0332 58.041ZM21.5042 44.7189C21.787 43.1411 22.0522 41.5647 22.2542 39.9786C22.5184 37.9877 22.6838 35.984 22.8053 33.9776C22.9179 31.9693 22.9576 29.9552 22.9262 27.9385C22.9071 25.9218 22.8022 23.9026 22.6511 21.8826C22.6471 21.8271 22.6944 21.78 22.7592 21.7755C22.7621 21.7755 22.765 21.7755 22.7678 21.7755C22.8311 21.7755 22.8864 21.8174 22.8933 21.873C23.1492 23.8922 23.3148 25.9173 23.4181 27.9437C23.5101 29.9694 23.5279 31.9964 23.4738 34.0209C23.4591 34.527 23.4397 35.0324 23.417 35.5379C23.3887 36.0434 23.3614 36.5482 23.3228 37.053C23.2597 37.9548 23.1799 38.8554 23.0832 39.7546C22.3516 41.4601 21.8433 43.1257 21.5042 44.7189Z"
      fill="#DCE6FD"
    />
    <path
      d="M23.4014 58.1904C22.909 58.5863 22.1689 58.3548 21.9868 57.7519C20.9819 54.4276 18.9972 44.7747 25.7848 34.8664C31.5167 26.499 33.8234 21.4214 34.7095 19.0439C34.8968 18.5416 35.6221 18.5682 35.7722 19.0832C37.4282 24.763 41.2468 43.8405 23.4014 58.1904Z"
      fill="#91B3FA"
    />
    <path
      d="M27.707 39.1074C28.9485 36.1029 30.4463 33.0295 32.2382 30.141C32.2849 30.066 32.3661 30.0244 32.4492 30.0244C32.4935 30.0244 32.5383 30.0363 32.5787 30.0607C32.6951 30.1321 32.7314 30.2832 32.6597 30.3986C31.3596 32.494 30.2152 34.6888 29.2122 36.8829C28.6895 37.6082 28.1867 38.3512 27.707 39.1074Z"
      fill="#C0D6FC"
    />
    <mask
      id="mask1_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="20"
      y="17"
      width="92"
      height="92"
    >
      <path
        d="M66.213 108.203C41.1047 108.203 20.75 88.0074 20.75 63.0952C20.75 62.6693 20.756 62.2435 20.7678 61.8207C20.8034 60.5459 20.8921 59.2869 21.0322 58.0409C21.1321 57.1519 21.258 56.2711 21.4091 55.3985C22.432 49.4966 24.6104 43.986 27.7053 39.1056C28.1849 38.3494 28.6878 37.6065 29.2105 36.8815C31.5092 33.6925 34.2169 30.8132 37.2564 28.3188C45.121 21.8644 55.2098 17.9869 66.213 17.9869C91.1516 17.9869 111.4 37.9085 111.673 62.5879C111.675 62.7563 111.676 62.9261 111.676 63.0952C111.676 86.5522 93.6281 105.828 70.5591 107.999C69.128 108.134 67.6797 108.203 66.213 108.203ZM60.0642 23.0505C40.444 26.0718 25.4265 42.9056 25.4265 63.2195C25.4265 85.6707 43.7702 103.871 66.3983 103.871C89.0263 103.871 107.37 85.6707 107.37 63.2195C107.37 42.8536 92.275 25.9855 72.5809 23.0276C71.3699 20.8675 69.0173 19.4158 66.3372 19.4158C66.2586 19.4158 66.1792 19.4171 66.1002 19.4195C63.4791 19.5031 61.2334 20.9562 60.0642 23.0505Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_514_140551)">
      <path
        d="M66.213 108.203C41.1046 108.203 20.75 88.0074 20.75 63.0951C20.75 62.6693 20.756 62.2434 20.7677 61.8207C20.8034 60.5459 20.8921 59.2869 21.0321 58.041C21.1321 57.1519 21.258 56.2708 21.4091 55.3987C22.432 49.4968 24.6104 43.9858 27.7052 39.1056C28.1848 38.349 28.6878 37.6067 29.2105 36.8813C31.5092 33.6925 34.2169 30.8129 37.2563 28.3187C45.121 21.8642 55.2098 17.9867 66.213 17.9867C91.1518 17.9867 111.4 37.9085 111.673 62.5878C111.676 62.7563 111.677 62.926 111.677 63.0951C111.677 86.5522 93.6279 105.828 70.5593 107.999C69.1281 108.134 67.6797 108.203 66.213 108.203ZM60.0642 23.0504C40.444 26.0721 25.4265 42.9056 25.4265 63.2194C25.4265 85.6707 43.7702 103.871 66.3983 103.871C89.0266 103.871 107.37 85.6707 107.37 63.2194C107.37 42.8532 92.2748 25.9857 72.5812 23.0273C71.3699 20.8676 69.0171 19.4156 66.3372 19.4156C66.2586 19.4156 66.1792 19.417 66.1002 19.4197C63.4791 19.5033 61.2334 20.956 60.0642 23.0504Z"
        fill="#858A9D"
      />
    </g>
    <path
      d="M107.371 63.2195C107.371 85.6708 89.0272 103.871 66.3997 103.871C43.7715 103.871 25.4277 85.6708 25.4277 63.2195C25.4277 40.7677 43.7715 22.5677 66.3997 22.5677C89.0272 22.5677 107.371 40.7677 107.371 63.2195Z"
      fill="white"
    />
    <mask
      id="mask2_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="60"
      y="19"
      width="13"
      height="5"
    >
      <path
        d="M60.0645 23.0508C61.2337 20.9565 63.4794 19.5033 66.1005 19.4198C66.1795 19.4174 66.2588 19.416 66.3375 19.416C69.0175 19.416 71.3702 20.8678 72.5812 23.0278C70.5646 22.7249 68.5007 22.5678 66.3986 22.5678C64.2439 22.5678 62.129 22.7328 60.0645 23.0508Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_514_140551)">
      <path
        d="M60.0645 23.0508C61.2337 20.9565 63.4794 19.5032 66.1004 19.42C66.1795 19.4174 66.2588 19.416 66.3375 19.416C69.0176 19.416 71.3705 20.8681 72.5812 23.0277C70.5649 22.7247 68.5007 22.5676 66.3985 22.5676C64.2439 22.5676 62.129 22.7327 60.0645 23.0508Z"
        fill="#4D648B"
      />
    </g>
    <path
      d="M66.3121 33.2988C62.4854 33.2988 59.3265 30.3389 59.2047 26.5851C59.1637 25.3076 59.479 24.0999 60.0641 23.0524C62.1287 22.734 64.2436 22.5693 66.398 22.5693C68.5005 22.5693 70.5642 22.7263 72.5808 23.0293C73.0994 23.9532 73.408 25.0065 73.4442 26.1315C73.5688 29.9622 70.4816 33.1694 66.5491 33.295C66.4697 33.2975 66.3909 33.2988 66.3121 33.2988Z"
      fill="white"
    />
    <mask
      id="mask3_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="58"
      y="18"
      width="17"
      height="17"
    >
      <path
        d="M66.5382 32.9421C62.8055 33.0609 59.6838 30.2094 59.5662 26.5726C59.4485 22.9358 62.3791 19.8912 66.1118 19.7721C69.8445 19.6533 72.9658 22.5048 73.0838 26.1416C73.2015 29.7784 70.2709 32.823 66.5382 32.9421ZM66.0752 18.6384C61.6997 18.7777 58.2644 22.3467 58.4025 26.6096C58.5405 30.8725 62.1993 34.2152 66.5748 34.0759C70.9502 33.9366 74.3855 30.3675 74.2475 26.1047C74.1095 21.8418 70.4507 18.499 66.0752 18.6384Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_514_140551)">
      <path
        d="M66.5383 32.9423C62.8055 33.0613 59.6839 30.2099 59.5662 26.5725C59.4486 22.9359 62.3791 19.8916 66.1118 19.7726C69.8444 19.6536 72.9656 22.5051 73.0842 26.1417C73.2014 29.779 70.2712 32.8233 66.5383 32.9423ZM66.0753 18.6384C61.6998 18.7781 58.2645 22.3469 58.4025 26.6098C58.5405 30.8727 62.1993 34.2155 66.5748 34.0759C70.95 33.9369 74.3855 30.3681 74.2474 26.1052C74.1094 21.8416 70.4508 18.4988 66.0753 18.6384Z"
        fill="url(#paint1_linear_514_140551)"
      />
    </g>
    <path
      d="M66.5326 32.7187C62.9259 32.8335 59.9101 30.0785 59.7963 26.5645C59.6824 23.0505 62.5139 20.1089 66.1207 19.994C69.7274 19.8791 72.7431 22.6342 72.8568 26.1482C72.9706 29.6622 70.139 32.6038 66.5326 32.7187ZM66.0851 18.8984C61.8577 19.0332 58.5383 22.4814 58.6719 26.6004C58.805 30.7193 62.3404 33.9491 66.5681 33.8143C70.7955 33.6795 74.1143 30.2312 73.9812 26.1123C73.848 21.9934 70.313 18.7636 66.0851 18.8984Z"
      fill="#91B3FA"
    />
    <mask
      id="mask4_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="58"
      y="19"
      width="13"
      height="9"
    >
      <path
        d="M59.019 25.3908L59.0107 25.3901C58.979 25.3853 58.9573 25.3565 58.9617 25.3254C59.0356 24.8256 59.1636 24.3326 59.3426 23.8596C60.3963 21.0724 63.0453 19.2088 66.0907 19.1116C67.5101 19.0671 68.9043 19.4139 70.1198 20.1167C70.1474 20.1324 70.1567 20.1673 70.1405 20.1944C70.1243 20.2218 70.0891 20.2307 70.0619 20.2152C68.865 19.5234 67.4953 19.1808 66.0945 19.2259C63.0957 19.3215 60.4877 21.1559 59.4503 23.8996C59.2743 24.3652 59.1484 24.8502 59.0759 25.3418C59.0714 25.3702 59.047 25.3908 59.019 25.3908ZM59.0345 27.5508C59.0066 27.5508 58.9821 27.5306 58.9776 27.5025C58.9483 27.3204 58.9255 27.1345 58.9103 26.9504C58.9079 26.9189 58.9314 26.8915 58.9631 26.8887C58.998 26.8874 59.0225 26.9096 59.0249 26.9411C59.04 27.1222 59.0621 27.305 59.0915 27.4847C59.0963 27.5155 59.0749 27.545 59.0435 27.5498L59.0345 27.5508Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_514_140551)">
      <path
        d="M59.019 25.391L59.0107 25.3903C58.979 25.3857 58.9572 25.3565 58.9617 25.3254C59.0355 24.8257 59.1636 24.3326 59.3426 23.86C60.3963 21.0726 63.0453 19.2094 66.0907 19.112C67.51 19.067 68.9043 19.4139 70.1198 20.1168C70.1471 20.1327 70.1565 20.1678 70.1404 20.1949C70.1244 20.2221 70.0891 20.2313 70.0617 20.2155C68.8649 19.5238 67.4953 19.1809 66.0945 19.2259C63.0957 19.3219 60.4877 21.156 59.4502 23.8997C59.2743 24.365 59.1484 24.8508 59.0759 25.342C59.0714 25.3704 59.047 25.391 59.019 25.391ZM59.0345 27.5508C59.0066 27.5508 58.982 27.5309 58.9776 27.5031C58.9483 27.3204 58.9255 27.1344 58.9103 26.9504C58.9079 26.9193 58.9313 26.8915 58.9631 26.8889C58.9979 26.8875 59.0225 26.9101 59.0249 26.9412C59.04 27.1225 59.0621 27.3052 59.0915 27.4846C59.0963 27.5157 59.0749 27.5448 59.0435 27.5501L59.0345 27.5508Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask5_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="65"
      y="27"
      width="4"
      height="5"
    >
      <path
        d="M68.5937 29.4775C68.5937 30.423 67.8213 31.1895 66.8683 31.1895C65.9151 31.1895 65.1426 30.423 65.1426 29.4775C65.1426 28.5317 65.9151 27.7652 66.8683 27.7652C67.8213 27.7652 68.5937 28.5317 68.5937 29.4775Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_514_140551)">
      <path
        d="M68.594 29.4769C68.594 30.423 67.8215 31.1895 66.8686 31.1895C65.9151 31.1895 65.1426 30.423 65.1426 29.4769C65.1426 28.5314 65.9151 27.765 66.8686 27.765C67.8215 27.765 68.594 28.5314 68.594 29.4769Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask6_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="66"
      y="25"
      width="2"
      height="2"
    >
      <path
        d="M67.6591 26.481C67.6591 26.7569 67.4338 26.9805 67.1557 26.9805C66.878 26.9805 66.6523 26.7569 66.6523 26.481C66.6523 26.2051 66.878 25.9816 67.1557 25.9816C67.4338 25.9816 67.6591 26.2051 67.6591 26.481Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_514_140551)">
      <path
        d="M67.6592 26.481C67.6592 26.7567 67.4337 26.9805 67.1558 26.9805C66.8778 26.9805 66.6523 26.7567 66.6523 26.481C66.6523 26.2052 66.8778 25.9814 67.1558 25.9814C67.4337 25.9814 67.6592 26.2052 67.6592 26.481Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask7_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="68"
      y="25"
      width="3"
      height="4"
    >
      <path
        d="M70.8229 27.0877C70.8229 27.6984 70.324 28.1934 69.7085 28.1934C69.093 28.1934 68.5938 27.6984 68.5938 27.0877C68.5938 26.477 69.093 25.982 69.7085 25.982C70.324 25.982 70.8229 26.477 70.8229 27.0877Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask7_514_140551)">
      <path
        d="M70.823 27.0891C70.823 27.7001 70.3239 28.1953 69.7087 28.1953C69.0928 28.1953 68.5938 27.7001 68.5938 27.0891C68.5938 26.4786 69.0928 25.9835 69.7087 25.9835C70.3239 25.9835 70.823 26.4786 70.823 27.0891Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask8_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="62"
      y="25"
      width="3"
      height="3"
    >
      <path
        d="M64.4939 26.7666C64.4939 27.3971 63.9788 27.9082 63.3436 27.9082C62.7081 27.9082 62.1934 27.3971 62.1934 26.7666C62.1934 26.1364 62.7081 25.6253 63.3436 25.6253C63.9788 25.6253 64.4939 26.1364 64.4939 26.7666Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask8_514_140551)">
      <path
        d="M64.4936 26.7663C64.4936 27.397 63.979 27.9082 63.3434 27.9082C62.7078 27.9082 62.1934 27.397 62.1934 26.7663C62.1934 26.1363 62.7078 25.6251 63.3434 25.6251C63.979 25.6251 64.4936 26.1363 64.4936 26.7663Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask9_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="63"
      y="29"
      width="1"
      height="1"
    >
      <path
        d="M63.9189 29.5485C63.9189 29.7063 63.7902 29.834 63.6315 29.834C63.4724 29.834 63.3438 29.7063 63.3438 29.5485C63.3438 29.391 63.4724 29.2633 63.6315 29.2633C63.7902 29.2633 63.9189 29.391 63.9189 29.5485Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask9_514_140551)">
      <path
        d="M63.9191 29.5486C63.9191 29.7063 63.7903 29.834 63.6314 29.834C63.4725 29.834 63.3438 29.7063 63.3438 29.5486C63.3438 29.3909 63.4725 29.2632 63.6314 29.2632C63.7903 29.2632 63.9191 29.3909 63.9191 29.5486Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask10_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="64"
      y="23"
      width="3"
      height="3"
    >
      <path
        d="M66.8671 24.3052C66.8671 24.9556 66.3358 25.4824 65.6806 25.4824C65.0255 25.4824 64.4941 24.9556 64.4941 24.3052C64.4941 23.6551 65.0255 23.1283 65.6806 23.1283C66.3358 23.1283 66.8671 23.6551 66.8671 24.3052Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask10_514_140551)">
      <path
        d="M66.8673 24.3054C66.8673 24.9554 66.3362 25.4824 65.6804 25.4824C65.0253 25.4824 64.4941 24.9554 64.4941 24.3054C64.4941 23.6554 65.0253 23.1284 65.6804 23.1284C66.3362 23.1284 66.8673 23.6554 66.8673 24.3054Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask11_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="69"
      y="28"
      width="1"
      height="2"
    >
      <path
        d="M69.96 29.0853C69.96 29.3414 69.7506 29.5488 69.4925 29.5488C69.2345 29.5488 69.0254 29.3414 69.0254 29.0853C69.0254 28.8289 69.2345 28.6215 69.4925 28.6215C69.7506 28.6215 69.96 28.8289 69.96 29.0853Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask11_514_140551)">
      <path
        d="M69.9603 29.0847C69.9603 29.3412 69.7505 29.5488 69.4926 29.5488C69.2347 29.5488 69.0254 29.3412 69.0254 29.0847C69.0254 28.8288 69.2347 28.6212 69.4926 28.6212C69.7505 28.6212 69.9603 28.8288 69.9603 29.0847Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask12_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="67"
      y="23"
      width="3"
      height="3"
    >
      <path
        d="M69.9591 24.2705C69.9591 24.901 69.444 25.4121 68.8088 25.4121C68.1733 25.4121 67.6582 24.901 67.6582 24.2705C67.6582 23.6403 68.1733 23.1292 68.8088 23.1292C69.444 23.1292 69.9591 23.6403 69.9591 24.2705Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask12_514_140551)">
      <path
        d="M69.9594 24.2688C69.9594 24.8991 69.4443 25.4102 68.8091 25.4102C68.1733 25.4102 67.6582 24.8991 67.6582 24.2688C67.6582 23.6386 68.1733 23.1275 68.8091 23.1275C69.4443 23.1275 69.9594 23.6386 69.9594 24.2688Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask13_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="62"
      y="23"
      width="2"
      height="2"
    >
      <path
        d="M63.1998 24.1998C63.1998 24.4757 62.9745 24.6992 62.6964 24.6992C62.4187 24.6992 62.1934 24.4757 62.1934 24.1998C62.1934 23.9239 62.4187 23.7003 62.6964 23.7003C62.9745 23.7003 63.1998 23.9239 63.1998 24.1998Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask13_514_140551)">
      <path
        d="M63.1998 24.1998C63.1998 24.4755 62.9745 24.6992 62.6964 24.6992C62.4186 24.6992 62.1934 24.4755 62.1934 24.1998C62.1934 23.9241 62.4186 23.7004 62.6964 23.7004C62.9745 23.7004 63.1998 23.9241 63.1998 24.1998Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask14_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="66"
      y="21"
      width="2"
      height="2"
    >
      <path
        d="M67.5152 21.9159C67.5152 22.1524 67.3224 22.3438 67.084 22.3438C66.8455 22.3438 66.6523 22.1524 66.6523 21.9159C66.6523 21.6793 66.8455 21.488 67.084 21.488C67.3224 21.488 67.5152 21.6793 67.5152 21.9159Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask14_514_140551)">
      <path
        d="M67.5148 21.9152C67.5148 22.1515 67.3224 22.3438 67.0836 22.3438C66.8455 22.3438 66.6523 22.1515 66.6523 21.9152C66.6523 21.679 66.8455 21.4874 67.0836 21.4874C67.3224 21.4874 67.5148 21.679 67.5148 21.9152Z"
        fill="#919ED0"
      />
    </g>
    <path
      d="M77.1275 41.9902H76.7871V18.1589L77.1275 16.4684V41.9902Z"
      fill="#91B3FA"
    />
    <path
      d="M78.6607 44.3574H75.2539L75.474 38.8941C75.4932 38.4055 75.8987 38.019 76.3923 38.019H77.5224C78.0153 38.019 78.4208 38.4055 78.4406 38.8941L78.6607 44.3574Z"
      fill="#91B3FA"
    />
    <path
      d="M82.6216 88.5566H71.293V44.8925C71.293 44.4104 71.687 44.0194 72.1729 44.0194H81.7416C82.2275 44.0194 82.6216 44.4104 82.6216 44.8925V88.5566Z"
      fill="#91B3FA"
    />
    <mask
      id="mask15_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="72"
      y="44"
      width="10"
      height="45"
    >
      <path
        d="M72.1445 88.8945V45.3951C72.1445 45.1021 72.384 44.8646 72.6793 44.8646H81.2346C81.5299 44.8646 81.7694 45.1021 81.7694 45.3951V88.8945H72.1445Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask15_514_140551)">
      <path
        d="M72.1445 88.8945V45.3953C72.1445 45.102 72.3842 44.8647 72.6793 44.8647H81.2348C81.5299 44.8647 81.7696 45.102 81.7696 45.3953V88.8945H72.1445Z"
        fill="url(#paint2_linear_514_140551)"
      />
    </g>
    <path
      d="M72.1445 88.8945V45.3953C72.1445 45.102 72.3842 44.8647 72.6793 44.8647H81.2348C81.5299 44.8647 81.7696 45.102 81.7696 45.3953V88.8945H72.1445Z"
      fill="#BDD0FB"
    />
    <mask
      id="mask16_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="72"
      y="44"
      width="10"
      height="19"
    >
      <path
        d="M72.1445 62.9043V45.3944C72.1445 45.1014 72.384 44.8638 72.6793 44.8638H81.2346C81.5299 44.8638 81.7694 45.1014 81.7694 45.3944V62.9043H72.1445Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask16_514_140551)">
      <path
        d="M72.1445 62.9043V45.3943C72.1445 45.101 72.3842 44.8637 72.6793 44.8637H81.2348C81.5299 44.8637 81.7696 45.101 81.7696 45.3943V62.9043H72.1445Z"
        fill="#9CB6FD"
      />
    </g>
    <mask
      id="mask17_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="76"
      y="63"
      width="2"
      height="37"
    >
      <path
        d="M77.5959 99.0352H76.3184V63.2027H77.5959V99.0352Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask17_514_140551)">
      <path
        d="M77.5961 99.0352H76.3184V63.2027H77.5961V99.0352Z"
        fill="url(#paint3_linear_514_140551)"
      />
    </g>
    <mask
      id="mask18_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="72"
      y="62"
      width="10"
      height="2"
    >
      <path
        d="M81.8011 63.3711H72.1445V62.0189H81.8011V63.3711Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask18_514_140551)">
      <path
        d="M81.801 63.3711H72.1445V62.0192H81.801V63.3711Z"
        fill="url(#paint4_linear_514_140551)"
      />
    </g>
    <path
      d="M83.8569 89.7402H70.0584C69.6819 89.7402 69.377 89.4376 69.377 89.0642C69.377 88.6907 69.6819 88.3881 70.0584 88.3881H83.8569C84.2329 88.3881 84.5384 88.6907 84.5384 89.0642C84.5384 89.4376 84.2329 89.7402 83.8569 89.7402Z"
      fill="#91B3FA"
    />
    <mask
      id="mask19_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="69"
      y="98"
      width="16"
      height="2"
    >
      <path
        d="M83.8628 99.6822L70.0564 99.7109C69.68 99.7109 69.375 99.408 69.375 99.0349C69.375 98.6614 69.68 98.3588 70.0564 98.3588H83.8549C84.2313 98.3588 84.5363 98.6614 84.5363 99.0349C84.5363 99.408 84.2389 99.6822 83.8628 99.6822Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask19_514_140551)">
      <path
        d="M83.8628 99.6822L70.0565 99.7109C69.68 99.7109 69.375 99.408 69.375 99.0348C69.375 98.6614 69.68 98.3588 70.0565 98.3588H83.855C84.2315 98.3588 84.5365 98.6614 84.5365 99.0348C84.5365 99.408 84.2393 99.6822 83.8628 99.6822Z"
        fill="url(#paint5_linear_514_140551)"
      />
    </g>
    <mask
      id="mask20_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="46"
      y="52"
      width="4"
      height="8"
    >
      <path
        d="M46.2578 59.3328C46.2578 59.3126 46.2578 59.2924 46.2582 59.2722C46.2582 59.2726 46.2585 59.2733 46.2585 59.2736C46.2582 59.2935 46.2578 59.313 46.2578 59.3328ZM46.57 57.7099C46.8778 56.9387 47.3981 56.2742 48.0588 55.7864C48.0733 55.7758 48.0878 55.7649 48.1023 55.7539C48.0898 55.7649 48.0774 55.7758 48.065 55.7864C47.397 56.3643 46.8785 57.0277 46.57 57.7099ZM49.474 53.5867C49.5137 53.3806 49.5344 53.1687 49.5344 52.9541V52.2838H49.5406V52.9541C49.5406 53.1711 49.5175 53.382 49.474 53.5867Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask20_514_140551)">
      <path
        d="M46.2578 59.3329C46.2578 59.3127 46.2578 59.2925 46.2578 59.2723C46.2578 59.2728 46.2583 59.2733 46.2583 59.2737C46.2578 59.2934 46.2578 59.3131 46.2578 59.3329ZM46.5701 57.7102C46.8778 56.9387 47.398 56.2741 48.0586 55.7864C48.073 55.7758 48.0877 55.7648 48.1021 55.7538C48.0896 55.7648 48.0771 55.7758 48.0646 55.7864C47.3971 56.3644 46.8783 57.0277 46.5701 57.7102ZM49.4737 53.5866C49.5134 53.3808 49.5342 53.1686 49.5342 52.9541V52.2839H49.5407V52.9541C49.5407 53.1713 49.5176 53.3822 49.4737 53.5866Z"
        fill="url(#paint6_linear_514_140551)"
      />
    </g>
    <path
      d="M64.0421 52.954V51.177H49.5407V52.954C49.5407 54.0797 48.9204 55.0468 48.0652 55.7864C46.8663 56.8237 46.148 58.1369 46.2642 59.3394V95.1708C46.2642 97.6157 48.2617 99.5977 50.7259 99.5977H62.8569C65.3211 99.5977 67.3188 97.6157 67.3188 95.1708V59.3394C67.3188 57.8838 66.6108 56.593 65.518 55.7864C64.607 55.1147 64.0421 54.0797 64.0421 52.954Z"
      fill="#91B3FA"
    />
    <path
      d="M46.2578 59.3392V95.1708C46.2578 97.6156 48.2555 99.5977 50.7196 99.5977H62.8503C65.3144 99.5977 67.3121 97.6156 67.3121 95.1708V59.3392C67.3121 59.1993 67.3041 59.0611 67.2907 58.9245H46.2793C46.2662 59.0611 46.2578 59.1993 46.2578 59.3392Z"
      fill="#91B3FA"
    />
    <path
      d="M65.966 58.9258H47.5664C47.9915 58.2774 48.8928 57.013 48.9015 56.9197H64.4177C64.4268 57.013 65.4725 58.2774 65.966 58.9258Z"
      fill="#C7D8FC"
    />
    <path
      d="M62.221 98.1465H51.3488C49.1402 98.1465 47.3496 96.3699 47.3496 94.1787V59.2975C47.3496 59.2682 47.4359 59.1262 47.5672 58.9258H65.9672C66.12 59.1262 66.2202 59.2682 66.2202 59.2975V94.1787C66.2202 96.3699 64.43 98.1465 62.221 98.1465Z"
      fill="#C7D8FC"
    />
    <mask
      id="mask21_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="46"
      y="61"
      width="22"
      height="28"
    >
      <path
        d="M67.3123 88.5312H46.2578V61.4156H67.3123V88.5312Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask21_514_140551)">
      <path
        d="M67.3124 88.5312H46.2578V61.4156H67.3124V88.5312Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask22_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="47"
      y="45"
      width="19"
      height="8"
    >
      <path
        d="M65.1848 52.2852H48.3823C48.1322 52.2852 47.9297 52.0839 47.9297 51.8357V46.0937C47.9297 45.8458 48.1322 45.6445 48.3823 45.6445H65.1848C65.435 45.6445 65.6378 45.8458 65.6378 46.0937V51.8357C65.6378 52.0839 65.435 52.2852 65.1848 52.2852ZM50.2109 46.6821V51.1093H54.3942V46.6821H50.2109Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask22_514_140551)">
      <path
        d="M65.1851 52.2852H64.0407H49.5391H49.533H48.3823C48.1322 52.2852 47.9297 52.0835 47.9297 51.8355V46.0936C47.9297 45.8455 48.1322 45.6444 48.3823 45.6444H65.1851C65.4351 45.6444 65.6379 45.8455 65.6379 46.0936V51.8355C65.6379 52.0835 65.4351 52.2852 65.1851 52.2852ZM50.2109 46.682V51.1092H54.3942V46.682H50.2109Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask23_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="47"
      y="63"
      width="19"
      height="8"
    >
      <path
        d="M65.2756 70.2695H48.292C48.0918 70.2695 47.9297 70.1086 47.9297 69.9101V64.2653C47.9297 64.0667 48.0918 63.9058 48.292 63.9058H65.2756C65.4757 63.9058 65.6378 64.0667 65.6378 64.2653V69.9101C65.6378 70.1086 65.4757 70.2695 65.2756 70.2695Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask23_514_140551)">
      <path
        d="M65.2753 70.2695H48.2917C48.0916 70.2695 47.9297 70.1089 47.9297 69.9103V64.2655C47.9297 64.067 48.0916 63.906 48.2917 63.906H65.2753C65.4754 63.906 65.6377 64.067 65.6377 64.2655V69.9103C65.6377 70.1089 65.4754 70.2695 65.2753 70.2695Z"
        fill="url(#paint7_linear_514_140551)"
      />
    </g>
    <path
      d="M50.9793 69.0176L50.2422 65.552H50.8121L51.0917 67.0173C51.1704 67.4286 51.2418 67.8248 51.2969 68.2568H51.3068C51.3649 67.8403 51.4367 67.4286 51.5154 67.0328L51.8087 65.552H52.3615L51.5868 69.0176H50.9793Z"
      fill="white"
    />
    <path
      d="M53.5408 67.5421L53.3975 66.8066C53.3565 66.6008 53.3155 66.3437 53.2817 66.1382H53.2748C53.2406 66.3437 53.2064 66.6061 53.1688 66.8066L53.0324 67.5421H53.5408ZM52.9572 68.1279L52.7934 69.0176H52.2539L52.9572 65.552H53.6396L54.3527 69.0176H53.7931L53.616 68.1279H52.9572Z"
      fill="white"
    />
    <path
      d="M56.2637 68.9216C56.1683 68.9933 55.9534 69.0703 55.6735 69.0703C54.8783 69.0703 54.4688 68.3247 54.4688 67.3376C54.4688 66.1551 55.0282 65.4967 55.7245 65.4967C55.9941 65.4967 56.1991 65.5793 56.2911 65.651L56.185 66.2732C56.0797 66.2064 55.9325 66.1445 55.7484 66.1445C55.3354 66.1445 55.0149 66.5204 55.0149 67.2916C55.0149 67.9851 55.2879 68.4225 55.7519 68.4225C55.9089 68.4225 56.0831 68.3711 56.185 68.3096L56.2637 68.9216Z"
      fill="white"
    />
    <path
      d="M58.1919 68.9216C58.096 68.9933 57.8812 69.0703 57.6013 69.0703C56.8061 69.0703 56.3965 68.3247 56.3965 67.3376C56.3965 66.1551 56.9563 65.4967 57.6526 65.4967C57.9218 65.4967 58.1268 65.5793 58.2189 65.651L58.1131 66.2732C58.0074 66.2064 57.8606 66.1445 57.6762 66.1445C57.2632 66.1445 56.943 66.5204 56.943 67.2916C56.943 67.9851 57.2156 68.4225 57.6796 68.4225C57.8367 68.4225 58.0108 68.3711 58.1131 68.3096L58.1919 68.9216Z"
      fill="white"
    />
    <path d="M59.0552 65.552V69.0176H58.5332V65.552H59.0552Z" fill="white" />
    <path
      d="M59.5059 69.0176V65.552H60.113L60.591 66.8221C60.7278 67.187 60.8638 67.619 60.9664 68.0099H60.9766C60.9424 67.5523 60.9322 67.0841 60.9322 66.565V65.552H61.4102V69.0176H60.8638L60.3725 67.6808C60.2361 67.3106 60.086 66.8632 59.9736 66.4568L59.9629 66.462C59.977 66.9197 59.9835 67.4083 59.9835 67.9741V69.0176H59.5059Z"
      fill="white"
    />
    <path
      d="M63.2277 67.5524H62.3815V68.375H63.3268V69.0176H61.8594V65.5521H63.279V66.1947H62.3815V66.9144H63.2277V67.5524Z"
      fill="white"
    />
    <mask
      id="mask24_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="50"
      y="46"
      width="5"
      height="6"
    >
      <path
        d="M50.2109 51.1094H54.3942V46.6822H50.2109V51.1094Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask24_514_140551)">
      <path
        d="M54.3941 51.1094H50.2109V46.682H54.3941V51.1094Z"
        fill="url(#paint8_linear_514_140551)"
      />
    </g>
    <mask
      id="mask25_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="47"
      y="77"
      width="20"
      height="2"
    >
      <path
        d="M66.2465 78.7773H47.9805V77.2554H66.2465V78.7773Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask25_514_140551)">
      <path
        d="M66.2463 78.7773H47.9805V77.2555H66.2463V78.7773Z"
        fill="url(#paint9_linear_514_140551)"
      />
    </g>
    <mask
      id="mask26_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="39"
      y="28"
      width="59"
      height="71"
    >
      <path
        d="M42.3074 98.6562L39.9316 96.7512L95.435 28.6115L97.8108 30.5165L42.3074 98.6562Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask26_514_140551)">
      <path
        d="M42.3074 98.6562L39.9316 96.7513L95.435 28.6113L97.8106 30.5163L42.3074 98.6562Z"
        fill="#858A9D"
      />
    </g>
    <mask
      id="mask27_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="103"
      y="107"
      width="4"
      height="4"
    >
      <path
        d="M106.364 109.89C106.364 109.866 106.362 109.84 106.356 109.815C105.977 108.324 104.427 107.56 104.427 107.56L103.682 107.618C103.253 108.932 102.977 109.573 103.046 109.933C103.047 109.942 103.051 109.952 103.053 109.962C103.668 110.016 104.934 110.052 106.364 109.89Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask27_514_140551)">
      <path
        d="M106.363 109.89C106.364 109.866 106.362 109.841 106.355 109.815C105.977 108.324 104.427 107.56 104.427 107.56L103.681 107.618C103.253 108.932 102.977 109.574 103.046 109.933C103.047 109.942 103.05 109.952 103.053 109.962C103.668 110.016 104.934 110.052 106.363 109.89Z"
        fill="url(#paint10_linear_514_140551)"
      />
    </g>
    <path
      d="M103.053 109.962C103.086 110.082 103.175 110.176 103.29 110.199C104.164 110.382 105.554 110.235 106.138 110.159C106.266 110.143 106.36 110.024 106.363 109.891C104.933 110.052 103.667 110.017 103.053 109.962Z"
      fill="#91B3FA"
    />
    <mask
      id="mask28_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="103"
      y="106"
      width="3"
      height="3"
    >
      <path
        d="M105.04 106.41L104.714 107.969C104.69 108.083 104.602 108.169 104.495 108.178C104.364 108.191 104.177 108.198 103.989 108.171C103.82 108.146 103.703 107.976 103.733 107.794L103.96 106.41H105.04Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask28_514_140551)">
      <path
        d="M105.041 106.41L104.715 107.969C104.691 108.083 104.602 108.169 104.495 108.179C104.364 108.191 104.176 108.198 103.989 108.171C103.821 108.146 103.703 107.976 103.733 107.794L103.96 106.41H105.041Z"
        fill="url(#paint11_linear_514_140551)"
      />
    </g>
    <path
      d="M96.719 109.948C97.5156 109.926 97.9268 109.833 98.1399 109.747C98.1405 109.825 98.1399 109.905 98.1375 109.988C98.1345 110.076 98.0689 110.147 97.9876 110.146L93.6164 110.118C93.4767 110.117 93.3954 109.957 93.4556 109.83C94.0288 109.877 95.4883 109.982 96.719 109.948Z"
      fill="#91B3FA"
    />
    <mask
      id="mask29_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="93"
      y="107"
      width="6"
      height="3"
    >
      <path
        d="M93.457 109.831C93.4626 109.819 93.467 109.808 93.4743 109.798C93.8604 109.263 94.8436 108.197 96.7864 107.735L97.7186 107.705C97.7186 107.705 98.1337 108.421 98.1413 109.747C97.9284 109.833 97.5168 109.926 96.7205 109.948C95.4899 109.983 94.0304 109.877 93.457 109.831Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask29_514_140551)">
      <path
        d="M93.457 109.831C93.4625 109.819 93.4673 109.808 93.4745 109.798C93.8604 109.263 94.8436 108.197 96.7866 107.735L97.7186 107.705C97.7186 107.705 98.1335 108.421 98.1413 109.747C97.9282 109.833 97.5169 109.926 96.7204 109.948C95.4897 109.983 94.0302 109.877 93.457 109.831Z"
        fill="url(#paint12_linear_514_140551)"
      />
    </g>
    <mask
      id="mask30_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="96"
      y="106"
      width="2"
      height="3"
    >
      <path
        d="M97.8915 106.304C97.8811 106.372 97.7531 107.42 97.7038 107.826C97.6921 107.923 97.6217 107.998 97.5327 108.008C97.374 108.027 97.1173 108.044 96.8927 107.998C96.7712 107.974 96.6836 107.858 96.6836 107.724V106.079L97.8915 106.304Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask30_514_140551)">
      <path
        d="M97.8913 106.304C97.8811 106.372 97.7532 107.42 97.7033 107.826C97.6919 107.923 97.6217 107.998 97.5328 108.008C97.3736 108.027 97.1172 108.044 96.8926 107.998C96.7713 107.974 96.6836 107.858 96.6836 107.724V106.079L97.8913 106.304Z"
        fill="url(#paint13_linear_514_140551)"
      />
    </g>
    <mask
      id="mask31_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="96"
      y="85"
      width="10"
      height="23"
    >
      <path
        d="M104.419 85.9382C104.419 85.9382 105.911 99.0917 105.082 107.312C105.082 107.312 104.088 107.312 103.59 107.148C103.59 107.148 102.041 94.2873 101.539 90.607C101.52 90.4684 101.321 90.4622 101.293 90.5995C100.675 93.6958 98.2451 105.837 97.9563 106.984C97.9563 106.984 97.1276 107.312 96.4648 106.984C96.4648 106.984 97.7904 89.3908 98.7847 86.2668L104.419 85.9382Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask31_514_140551)">
      <path
        d="M104.419 85.9382C104.419 85.9382 105.911 99.0917 105.082 107.312C105.082 107.312 104.088 107.312 103.591 107.148C103.591 107.148 102.04 94.2873 101.54 90.607C101.52 90.4684 101.321 90.4622 101.293 90.5995C100.675 93.6958 98.2452 105.837 97.9563 106.984C97.9563 106.984 97.1279 107.312 96.4648 106.984C96.4648 106.984 97.7902 89.3908 98.7848 86.2668L104.419 85.9382Z"
        fill="url(#paint14_linear_514_140551)"
      />
    </g>
    <mask
      id="mask32_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="100"
      y="66"
      width="4"
      height="5"
    >
      <path
        d="M103.026 66.1547L103.653 70.3638C103.653 70.3638 101.901 71.1628 100.674 70.3296L100.938 67.359L103.026 66.1547Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask32_514_140551)">
      <path
        d="M103.026 66.1547L103.653 70.3638C103.653 70.3638 101.901 71.1628 100.674 70.3296L100.938 67.359L103.026 66.1547Z"
        fill="url(#paint15_linear_514_140551)"
      />
    </g>
    <mask
      id="mask33_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="99"
      y="62"
      width="5"
      height="6"
    >
      <path
        d="M101.195 63.0629C101.153 63.1023 99.4062 66.5052 99.4062 66.5052L101.386 67.4531L103.524 64.4722C103.524 64.4722 101.905 62.3998 101.195 63.0629Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask33_514_140551)">
      <path
        d="M101.195 63.0627C101.152 63.1024 99.4062 66.5052 99.4062 66.5052L101.386 67.4531L103.524 64.4722C103.524 64.4722 101.905 62.3998 101.195 63.0627Z"
        fill="url(#paint16_linear_514_140551)"
      />
    </g>
    <mask
      id="mask34_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="98"
      y="61"
      width="7"
      height="8"
    >
      <path
        d="M102.647 64.5538C102.682 64.6442 102.674 64.7455 102.624 64.8287L101.636 66.4615C101.621 66.4865 101.603 66.5088 101.582 66.5286C101.465 66.6371 101.062 66.9527 100.751 66.5228C100.486 66.1565 100.238 65.8234 99.9717 65.6862C99.8161 65.6061 99.6246 65.6701 99.5456 65.8255C99.3831 66.1452 99.0681 66.7973 98.8701 67.4156C98.8204 67.5706 98.9012 67.737 99.053 67.7979C99.4539 67.9592 100.246 68.2505 100.949 68.3467C101.064 68.3624 101.179 68.3141 101.247 68.2207C101.55 67.8096 102.402 66.6608 102.693 66.3732C102.963 66.1062 103.462 66.2068 103.687 66.2709C103.772 66.2955 103.863 66.2835 103.939 66.238C104.167 66.1017 104.565 65.7625 104.201 65.1878C104.111 65.045 104.157 64.8547 104.299 64.7619C104.554 64.5959 104.83 64.284 104.567 63.7788C104.3 63.2674 103.824 63.2215 103.5 63.2608C103.357 63.278 103.211 63.2033 103.156 63.0709C103.132 63.012 103.083 62.9617 102.993 62.9435C102.823 62.9093 102.712 62.7552 102.745 62.5865C102.802 62.2972 102.759 61.9214 102.294 61.6674C101.44 61.2015 100.691 61.9604 100.501 62.6012C100.311 63.242 101.266 63.6949 101.867 63.7706C102.308 63.826 102.55 64.3039 102.647 64.5538Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask34_514_140551)">
      <path
        d="M102.647 64.5538C102.682 64.6442 102.674 64.7455 102.624 64.8287L101.636 66.4615C101.621 66.4865 101.603 66.5088 101.582 66.5286C101.465 66.6372 101.062 66.9528 100.751 66.5228C100.487 66.1565 100.238 65.8235 99.9716 65.6862C99.8162 65.6061 99.6248 65.6701 99.5458 65.8255C99.3834 66.1452 99.0681 66.7974 98.8703 67.4156C98.8202 67.5707 98.9011 67.737 99.0527 67.7979C99.454 67.9592 100.246 68.2505 100.949 68.3467C101.065 68.3625 101.179 68.3142 101.247 68.2207C101.55 67.8096 102.402 66.6607 102.693 66.3732C102.963 66.1062 103.462 66.2068 103.687 66.2709C103.773 66.2955 103.863 66.2835 103.94 66.238C104.168 66.1018 104.565 65.7625 104.201 65.1878C104.111 65.045 104.157 64.8547 104.299 64.7619C104.553 64.5959 104.83 64.284 104.566 63.7788C104.3 63.2673 103.824 63.2215 103.5 63.261C103.356 63.2782 103.211 63.2036 103.156 63.0711C103.132 63.0118 103.084 62.9615 102.994 62.9437C102.823 62.9092 102.712 62.7551 102.745 62.5862C102.802 62.2969 102.759 61.9217 102.294 61.6674C101.44 61.2017 100.691 61.9605 100.501 62.6015C100.311 63.2418 101.266 63.6949 101.867 63.7706C102.308 63.8261 102.55 64.3039 102.647 64.5538Z"
        fill="url(#paint17_linear_514_140551)"
      />
    </g>
    <mask
      id="mask35_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="102"
      y="65"
      width="2"
      height="3"
    >
      <path
        d="M102.322 66.9736C102.322 66.9736 102.702 65.871 103.188 65.9117C103.674 65.9521 104.057 66.4324 103.455 66.9726C102.705 67.6445 102.322 66.9736 102.322 66.9736Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask35_514_140551)">
      <path
        d="M102.322 66.9736C102.322 66.9736 102.702 65.871 103.188 65.9117C103.674 65.9521 104.057 66.4324 103.455 66.9726C102.705 67.6445 102.322 66.9736 102.322 66.9736Z"
        fill="url(#paint18_linear_514_140551)"
      />
    </g>
    <mask
      id="mask36_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="96"
      y="70"
      width="12"
      height="17"
    >
      <path
        d="M107.401 70.6479C107.401 70.6479 101.104 69.6613 96.1328 70.9765L96.4644 76.0736C96.4644 76.0736 97.7899 83.1435 98.7842 86.2675C98.7842 86.2675 102.596 86.9255 104.419 85.9389C104.419 85.9389 105.91 77.0602 106.739 75.7447C106.739 75.7447 107.567 72.292 107.401 70.6479Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask36_514_140551)">
      <path
        d="M107.401 70.6479C107.401 70.6479 101.104 69.6614 96.1328 70.9765L96.4643 76.0737C96.4643 76.0737 97.7896 83.1435 98.7841 86.2675C98.7841 86.2675 102.595 86.9255 104.418 85.9389C104.418 85.9389 105.91 77.0602 106.738 75.7447C106.738 75.7447 107.567 72.2921 107.401 70.6479Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask37_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="105"
      y="70"
      width="7"
      height="16"
    >
      <path
        d="M107.4 70.6483C107.4 70.6483 117.177 81.1712 105.66 85.1992V84.3773C105.66 84.3773 109.969 80.76 106.654 75.8276C106.654 75.8276 107.069 71.1416 107.4 70.6483Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask37_514_140551)">
      <path
        d="M107.4 70.6483C107.4 70.6483 117.177 81.1712 105.66 85.1992V84.3773C105.66 84.3773 109.969 80.76 106.655 75.8276C106.655 75.8276 107.069 71.1416 107.4 70.6483Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask38_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="88"
      y="63"
      width="10"
      height="14"
    >
      <path
        d="M97.9935 76.9434C97.9935 76.9434 83.6088 73.0584 90.7513 63.0675L91.2347 63.7463C91.2347 63.7463 89.4792 70.2456 96.6079 70.8884C96.6079 70.8884 98.0576 75.8811 97.9935 76.9434Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask38_514_140551)">
      <path
        d="M97.9935 76.9434C97.9935 76.9434 83.6089 73.0584 90.7513 63.0678L91.2346 63.746C91.2346 63.746 89.4791 70.2455 96.6077 70.8884C96.6077 70.8884 98.0572 75.8811 97.9935 76.9434Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask39_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="90"
      y="61"
      width="3"
      height="3"
    >
      <path
        d="M90.7035 63.1188C90.7035 63.1188 90.5416 61.1899 91.5136 61.029C92.4858 60.8684 92.8098 61.8328 92.9719 62.3151C93.1337 62.7974 91.5135 63.7617 91.1896 63.7617C90.8656 63.7617 90.7035 63.1188 90.7035 63.1188Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask39_514_140551)">
      <path
        d="M90.7034 63.1187C90.7034 63.1187 90.542 61.1898 91.514 61.0291C92.4861 60.8683 92.8101 61.8328 92.9721 62.315C93.1341 62.7973 91.514 63.7617 91.19 63.7617C90.866 63.7617 90.7034 63.1187 90.7034 63.1187Z"
        fill="url(#paint19_linear_514_140551)"
      />
    </g>
    <path
      d="M111.545 51.0868L109.625 60.3069C109.477 61.0221 108.764 61.4763 108.048 61.312C105.303 60.6824 98.7111 59.5692 93.1688 61.7556C92.4242 62.0494 91.5898 61.6286 91.4015 60.8557L88.8786 50.4935C88.7395 49.9219 89.0033 49.3272 89.5232 49.0465C95.517 45.808 103.747 45.1501 110.961 49.7241C111.421 50.0157 111.655 50.5567 111.545 51.0868Z"
      fill="#91B3FA"
    />
    <mask
      id="mask40_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="102"
      y="83"
      width="4"
      height="3"
    >
      <path
        d="M105.579 84.459C105.579 84.459 104.087 83.4725 103.424 83.8014C102.762 84.1301 102.762 84.6234 102.762 84.6234C102.762 84.6234 103.093 85.2809 103.59 85.1166C104.087 84.9523 105.247 85.2809 105.744 85.1166C105.744 85.1166 105.91 84.459 105.579 84.459Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask40_514_140551)">
      <path
        d="M105.579 84.459C105.579 84.459 104.088 83.4725 103.424 83.8014C102.762 84.1301 102.762 84.6233 102.762 84.6233C102.762 84.6233 103.093 85.2809 103.59 85.1166C104.088 84.9523 105.247 85.2809 105.745 85.1166C105.745 85.1166 105.911 84.459 105.579 84.459Z"
        fill="url(#paint20_linear_514_140551)"
      />
    </g>
    <path
      d="M103.317 55.9537L101.755 56.9316L98.5723 51.9288L100.134 50.9508L103.317 55.9537Z"
      fill="white"
    />
    <path
      d="M103.673 55.9928L101.637 57.2676L101.449 56.9722L103.485 55.6975L103.673 55.9928Z"
      fill="white"
    />
    <path
      d="M104.909 57.9318L102.873 59.207L102.686 58.912L104.721 57.6368L104.909 57.9318Z"
      fill="white"
    />
    <path
      d="M99.7737 51.5481L99.27 51.8633L98.6426 50.877L99.1463 50.5618L99.7737 51.5481Z"
      fill="white"
    />
    <path
      d="M99.3241 51.2218L99.1669 51.3203L97.7989 49.171L97.5332 48.408L99.3241 51.2218Z"
      fill="white"
    />
    <path
      d="M103.976 58.3092L103.615 58.5352L102.121 56.1871L102.482 55.9605L103.976 58.3092Z"
      fill="white"
    />
    <path
      d="M100.782 57.7403C99.8366 57.7403 98.9636 57.4235 98.2661 56.8908L103.752 50.7901C104.472 51.5284 104.915 52.5334 104.915 53.6393C104.915 55.9006 103.062 57.7403 100.782 57.7403ZM96.6489 53.6393C96.6489 51.3781 98.5031 49.5384 100.782 49.5384C101.713 49.5384 102.574 49.8455 103.266 50.3635L97.7836 56.459C97.0809 55.7238 96.6489 54.7304 96.6489 53.6393ZM104.164 50.2838C103.261 49.388 102.06 48.8939 100.782 48.8939C99.505 48.8939 98.3043 49.388 97.4008 50.2838C96.4974 51.1802 96 52.3722 96 53.6393C96 54.9071 96.4974 56.0985 97.4008 56.9949C98.3043 57.8913 99.505 58.3848 100.782 58.3848C102.06 58.3848 103.261 57.8913 104.164 56.9949C105.068 56.0985 105.565 54.9071 105.565 53.6393C105.565 52.3722 105.068 51.1802 104.164 50.2838Z"
      fill="white"
    />
    <mask
      id="mask41_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="31"
      y="71"
      width="8"
      height="8"
    >
      <path
        d="M31.3496 71.8741C31.3496 71.8741 39.0194 74.9111 38.3777 77.2995C37.7356 79.6875 33.5638 75.7074 33.5638 75.7074L31.3496 71.8741Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask41_514_140551)">
      <path
        d="M31.3496 71.8741C31.3496 71.8741 39.0194 74.9111 38.3777 77.2995C37.7356 79.6875 33.5638 75.7074 33.5638 75.7074L31.3496 71.8741Z"
        fill="url(#paint21_linear_514_140551)"
      />
    </g>
    <path
      d="M36.9334 82.8711H36.1309V61.2196H36.9334V82.8711Z"
      fill="#7D97F4"
    />
    <path
      d="M27.1675 47.5815L28.573 61.4004C28.6713 62.3659 29.5213 63.0823 30.4977 63.0218L42.5483 62.2744C43.465 62.2174 44.1953 61.4919 44.2516 60.5822L45.1455 46.1369C45.2142 45.0285 44.2678 44.1219 43.1538 44.2287L28.8038 45.6025C27.8 45.6986 27.0663 46.5859 27.1675 47.5815Z"
      fill="#91B3FA"
    />
    <mask
      id="mask42_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="21"
      y="65"
      width="9"
      height="12"
    >
      <path
        d="M28.3255 65.0159C28.3255 65.0159 27.2999 65.5105 27.1114 66.0791C26.9601 66.5354 25.826 66.5943 25.7141 67.4915C25.6562 67.9547 25.3107 68.3258 24.8457 68.3963C23.6875 68.5726 21.9027 69.1692 21.6171 71.1643C21.3991 72.6872 22.1815 73.2647 23.0027 73.4646C23.6058 73.6115 24.0066 74.1934 23.8847 74.7976C23.7676 75.3772 23.9421 76.0471 24.9539 76.5766C27.2213 77.7638 29.4856 73.7645 29.4856 73.7645L29.9497 66.7816L28.3255 65.0159Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask42_514_140551)">
      <path
        d="M28.3255 65.0159C28.3255 65.0159 27.2999 65.5106 27.1114 66.0792C26.96 66.5355 25.826 66.5944 25.714 67.4915C25.6562 67.9547 25.3107 68.3258 24.8457 68.3962C23.6875 68.5726 21.9027 69.1693 21.617 71.1642C21.3991 72.6872 22.1815 73.2648 23.0027 73.4645C23.6059 73.6116 24.0067 74.1935 23.8847 74.7977C23.7676 75.3772 23.9421 76.0469 24.9539 76.5766C27.2213 77.7638 29.4856 73.7645 29.4856 73.7645L29.9497 66.7815L28.3255 65.0159Z"
        fill="url(#paint22_linear_514_140551)"
      />
    </g>
    <mask
      id="mask43_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="108"
      width="4"
      height="3"
    >
      <path
        d="M19.0062 108.8L18.8595 109.997C18.8316 110.224 18.6514 110.404 18.4224 110.429C18.0358 110.473 17.4152 110.518 16.8081 110.455C16.5417 110.427 16.3687 110.159 16.4498 109.906C16.5978 109.444 16.8686 108.75 17.259 108.342H18.597C18.8443 108.342 19.036 108.557 19.0062 108.8Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask43_514_140551)">
      <path
        d="M19.0062 108.8L18.8595 109.997C18.8316 110.224 18.6514 110.404 18.4224 110.429C18.0358 110.473 17.4152 110.518 16.8081 110.455C16.5417 110.427 16.3687 110.159 16.4498 109.906C16.5978 109.444 16.8686 108.75 17.259 108.342H18.597C18.8443 108.342 19.036 108.557 19.0062 108.8Z"
        fill="url(#paint23_linear_514_140551)"
      />
    </g>
    <mask
      id="mask44_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="26"
      y="94"
      width="5"
      height="17"
    >
      <path
        d="M29.4863 94.7809L29.7121 96.0988C29.7121 96.0988 28.9558 103.7 28.8213 106.74C28.8002 107.217 28.9245 107.688 29.1767 108.094L30.4917 110.213L27.1495 108.256L27.083 107.851L27.6301 107.105L26.9134 98.5902C26.8714 98.09 26.9753 97.5885 27.2131 97.1452L27.9044 95.8568L29.4863 94.7809Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask44_514_140551)">
      <path
        d="M29.4863 94.7809L29.7121 96.0988C29.7121 96.0988 28.9558 103.7 28.8213 106.74C28.8002 107.217 28.9245 107.688 29.1767 108.094L30.4917 110.213L27.1495 108.256L27.083 107.851L27.6301 107.105L26.9134 98.5902C26.8714 98.09 26.9753 97.5885 27.2131 97.1452L27.9044 95.8568L29.4863 94.7809Z"
        fill="url(#paint24_linear_514_140551)"
      />
    </g>
    <mask
      id="mask45_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="26"
      y="107"
      width="5"
      height="4"
    >
      <path
        d="M30.7122 110.52H29.6457C29.446 110.52 29.2577 110.429 29.136 110.272C28.8035 109.843 28.1146 109.007 27.7852 108.985C27.3418 108.955 27.3984 110.52 27.3984 110.52H27.1499L26.8351 108.576C26.7558 108.087 27.001 107.603 27.4436 107.373C27.4436 107.373 27.5449 108.117 28.0946 108.446C28.6442 108.775 30.3312 109.953 30.3312 109.953C30.3312 109.953 30.5378 109.924 30.7647 109.965C31.1012 110.025 31.0542 110.52 30.7122 110.52Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask45_514_140551)">
      <path
        d="M30.7122 110.52H29.6457C29.446 110.52 29.2577 110.429 29.136 110.272C28.8035 109.843 28.1146 109.007 27.7852 108.985C27.3418 108.955 27.3984 110.52 27.3984 110.52H27.1499L26.8351 108.576C26.7558 108.087 27.001 107.603 27.4436 107.373C27.4436 107.373 27.5449 108.117 28.0946 108.446C28.6442 108.775 30.3312 109.953 30.3312 109.953C30.3312 109.953 30.5378 109.924 30.7647 109.965C31.1012 110.025 31.0542 110.52 30.7122 110.52Z"
        fill="url(#paint25_linear_514_140551)"
      />
    </g>
    <mask
      id="mask46_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="94"
      width="9"
      height="16"
    >
      <path
        d="M24.9085 95.4084C24.9085 95.4084 20.478 103.747 19.7737 105.651C19.0694 107.555 18.8227 109.143 18.8132 109.293C18.7985 109.528 18.5039 109.754 17.6918 109.754C17.2727 109.754 17.0675 109.587 16.967 109.426C16.8812 109.288 16.8768 109.116 16.949 108.971C17.2054 108.456 18.0187 106.812 18.3199 106.066C18.6795 105.175 19.4531 101.139 19.8774 99.736C20.3017 98.3325 20.7812 96.8105 22.6288 95.4084C22.6288 95.4084 23.8971 94.1757 24.9085 95.4084Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask46_514_140551)">
      <path
        d="M24.9085 95.4084C24.9085 95.4084 20.478 103.747 19.7737 105.651C19.0694 107.555 18.8227 109.143 18.8132 109.293C18.7985 109.528 18.5039 109.754 17.6918 109.754C17.2727 109.754 17.0675 109.587 16.967 109.426C16.8812 109.288 16.8768 109.116 16.949 108.971C17.2054 108.456 18.0187 106.812 18.3199 106.066C18.6795 105.175 19.4531 101.139 19.8774 99.736C20.3017 98.3325 20.7812 96.8105 22.6288 95.4084C22.6288 95.4084 23.8971 94.1757 24.9085 95.4084Z"
        fill="url(#paint26_linear_514_140551)"
      />
    </g>
    <path
      d="M27.707 81.7447C28.8499 76.9399 25.8613 74.5926 25.8613 74.5926C26.0218 72.6821 31.11 71.6904 31.11 71.6904C31.11 71.6904 34.2861 73.9942 33.9094 75.7976C33.6885 76.8547 31.6768 82.1284 31.6768 82.1284C31.6768 82.1284 29.8167 83.002 27.707 81.7447Z"
      fill="#BDD0FB"
    />
    <mask
      id="mask47_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="22"
      y="81"
      width="10"
      height="16"
    >
      <path
        d="M25.1737 84.1235C25.6388 82.733 27.7076 81.7444 27.7076 81.7444C29.8173 83.0017 31.6775 82.1281 31.6775 82.1281C31.6775 82.1281 32.0947 83.7103 31.8067 85.1806C31.5188 86.6508 29.7123 96.0998 29.7123 96.0998C26.8659 96.6722 22.4883 95.5244 22.4883 95.5244C24.3013 92.3306 24.7085 85.5136 25.1737 84.1235Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask47_514_140551)">
      <path
        d="M25.1737 84.1235C25.6388 82.733 27.7076 81.7444 27.7076 81.7444C29.8173 83.0017 31.6775 82.1281 31.6775 82.1281C31.6775 82.1281 32.0947 83.7103 31.8067 85.1806C31.5188 86.6508 29.7123 96.0998 29.7123 96.0998C26.8659 96.6722 22.4883 95.5244 22.4883 95.5244C24.3013 92.3306 24.7085 85.5136 25.1737 84.1235Z"
        fill="#919ED0"
      />
    </g>
    <mask
      id="mask48_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="28"
      y="68"
      width="3"
      height="5"
    >
      <path
        d="M29.0336 68.5144L28.1043 72.6554C28.0153 73.0203 28.3505 72.9607 28.7222 72.8909C29.3309 72.7773 30.1154 72.5428 30.3777 72.0728C30.4043 72.0248 30.4176 71.9708 30.4252 71.9167L30.8244 69.0453C30.8561 68.8173 30.7319 68.5962 30.5201 68.5031L29.7497 68.1642C29.4531 68.0338 29.1098 68.2015 29.0336 68.5144Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask48_514_140551)">
      <path
        d="M29.0335 68.5142L28.1043 72.6554C28.0153 73.0203 28.3505 72.9607 28.7222 72.891C29.3309 72.7772 30.1154 72.5427 30.3777 72.0728C30.4043 72.0247 30.4177 71.9705 30.4252 71.9167L30.8244 69.0452C30.8561 68.8173 30.732 68.5962 30.5201 68.503L29.7497 68.1641C29.4531 68.0337 29.1098 68.2013 29.0335 68.5142Z"
        fill="url(#paint27_linear_514_140551)"
      />
    </g>
    <mask
      id="mask49_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="28"
      y="64"
      width="5"
      height="6"
    >
      <path
        d="M30.1237 64.5717C30.1237 64.5717 31.2242 65.0328 31.9724 66.6106C32.7207 68.1883 32.1619 68.9168 31.4601 69.0167C30.7581 69.1167 29.7085 69.1016 28.5982 68.0822C27.4879 67.0631 28.6931 64.0251 30.1237 64.5717Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask49_514_140551)">
      <path
        d="M30.1237 64.572C30.1237 64.572 31.2242 65.0328 31.9724 66.6105C32.7207 68.1885 32.1619 68.917 31.46 69.0167C30.7581 69.1167 29.7085 69.1018 28.5982 68.0823C27.4879 67.0633 28.6931 64.0252 30.1237 64.572Z"
        fill="url(#paint28_linear_514_140551)"
      />
    </g>
    <mask
      id="mask50_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="26"
      y="63"
      width="6"
      height="6"
    >
      <path
        d="M29.3451 67.2406C29.3451 67.2406 28.5148 64.932 30.5775 64.905L31.0628 65.2415C31.0628 65.2415 31.8197 63.9616 30.5775 63.3505C29.3353 62.7398 27.8814 63.2444 27.3528 64.905C26.8242 66.5652 26.7339 67.6767 27.6134 68.4713C28.4929 69.2658 28.8553 68.3651 28.8553 68.3651C28.8553 68.3651 28.3764 67.622 28.5713 67.2242C28.7663 66.8268 29.216 67.3067 29.216 67.3067L29.3451 67.2406Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask50_514_140551)">
      <path
        d="M29.3451 67.2406C29.3451 67.2406 28.5147 64.9319 30.5775 64.9049L31.0629 65.2416C31.0629 65.2416 31.8197 63.9617 30.5775 63.3505C29.3353 62.7397 27.8814 63.2443 27.3528 64.9049C26.8242 66.5651 26.7339 67.6769 27.6134 68.4712C28.4929 69.2658 28.8553 68.3653 28.8553 68.3653C28.8553 68.3653 28.3764 67.622 28.5713 67.2241C28.7663 66.827 29.216 67.3068 29.216 67.3068L29.3451 67.2406Z"
        fill="url(#paint29_linear_514_140551)"
      />
    </g>
    <mask
      id="mask51_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="27"
      y="66"
      width="3"
      height="3"
    >
      <path
        d="M29.1133 67.497C29.1133 67.497 28.6935 66.3078 28.1335 66.7816C27.5735 67.255 28.5886 67.8797 28.9861 68.082L29.1133 67.497Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask51_514_140551)">
      <path
        d="M29.1133 67.4969C29.1133 67.4969 28.6935 66.3077 28.1335 66.7814C27.5735 67.2552 28.5886 67.8796 28.9861 68.082L29.1133 67.4969Z"
        fill="url(#paint30_linear_514_140551)"
      />
    </g>
    <mask
      id="mask52_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="25"
      y="73"
      width="12"
      height="8"
    >
      <path
        d="M25.8616 74.5925C25.8616 74.5925 24.8989 79.528 29.0708 80.8015C33.2427 82.0752 36.1547 76.4855 36.1547 76.4855C36.1547 76.4855 36.9334 75.7071 36.9334 74.7517C36.9334 73.7966 36.1308 73.1195 36.1308 73.1195C36.1308 73.1195 34.8474 74.9109 34.8474 75.8663C34.8474 76.8213 30.8359 79.528 29.3918 78.7318C27.9882 77.9582 27.9679 76.375 28.0455 75.6318C28.076 75.3391 27.9864 75.0478 27.7914 74.8267C27.3595 74.3365 26.4156 73.823 25.8616 74.5925Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask52_514_140551)">
      <path
        d="M25.8616 74.5925C25.8616 74.5925 24.8989 79.528 29.0708 80.8015C33.2427 82.0752 36.1547 76.4855 36.1547 76.4855C36.1547 76.4855 36.9334 75.7071 36.9334 74.7517C36.9334 73.7966 36.1308 73.1195 36.1308 73.1195C36.1308 73.1195 34.8474 74.9109 34.8474 75.8663C34.8474 76.8213 30.8359 79.528 29.3918 78.7318C27.9882 77.9582 27.9679 76.375 28.0455 75.6318C28.076 75.3391 27.9864 75.0478 27.7914 74.8267C27.3595 74.3365 26.4156 73.823 25.8616 74.5925Z"
        fill="url(#paint31_linear_514_140551)"
      />
    </g>
    <mask
      id="mask53_514_140551"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x="35"
      y="76"
      width="3"
      height="3"
    >
      <path
        d="M37.2372 76.7396L37.1174 78.4066C37.1026 78.611 36.8804 78.7356 36.6989 78.638C36.533 78.5487 36.3322 78.3796 36.1311 78.0612C35.6894 77.3605 36.0586 76.4982 36.9912 76.4845C37.1326 76.4825 37.2475 76.5995 37.2372 76.7396Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask53_514_140551)">
      <path
        d="M37.2372 76.7396L37.1174 78.4066C37.1026 78.611 36.8804 78.7356 36.6989 78.638C36.533 78.5487 36.3322 78.3796 36.1311 78.0612C35.6894 77.3605 36.0586 76.4982 36.9912 76.4845C37.1326 76.4825 37.2475 76.5995 37.2372 76.7396Z"
        fill="url(#paint32_linear_514_140551)"
      />
    </g>
    <path
      d="M33.6035 56.4687L35.2313 57.4883L38.5497 52.2734L36.9219 51.2538L33.6035 56.4687Z"
      fill="white"
    />
    <path
      d="M33.2324 56.5092L35.3544 57.8379L35.55 57.5299L33.4282 56.2013L33.2324 56.5092Z"
      fill="white"
    />
    <path
      d="M31.9453 58.5302L34.0671 59.8594L34.263 59.5514L32.1411 58.2227L31.9453 58.5302Z"
      fill="white"
    />
    <path
      d="M37.2988 51.8747L37.8236 52.2031L38.4781 51.1748L37.953 50.8464L37.2988 51.8747Z"
      fill="white"
    />
    <path
      d="M37.7656 51.5362L37.9295 51.6387L39.3554 49.3983L39.6322 48.6023L37.7656 51.5362Z"
      fill="white"
    />
    <path
      d="M32.916 58.9244L33.2924 59.1602L34.8499 56.7121L34.4736 56.4763L32.916 58.9244Z"
      fill="white"
    />
    <path
      d="M31.9384 54.0577C31.9384 52.9046 32.401 51.8571 33.1514 51.0873L38.8701 57.4466C38.1432 58.0019 37.2334 58.3325 36.247 58.3325C33.8713 58.3325 31.9384 56.4144 31.9384 54.0577ZM39.3728 56.9969L33.6583 50.6425C34.3795 50.1025 35.2765 49.7828 36.247 49.7828C38.6227 49.7828 40.5559 51.7004 40.5559 54.0577C40.5559 55.1949 40.1056 56.23 39.3728 56.9969ZM31.2617 54.0577C31.2617 55.3789 31.7803 56.6209 32.7219 57.5551C33.6635 58.4893 34.9155 59.0039 36.247 59.0039C37.5787 59.0039 38.8308 58.4893 39.7723 57.5551C40.7139 56.6209 41.2324 55.3789 41.2324 54.0577C41.2324 52.7359 40.7139 51.494 39.7723 50.5598C38.8308 49.6256 37.5787 49.1109 36.247 49.1109C34.9155 49.1109 33.6635 49.6256 32.7219 50.5598C31.7803 51.494 31.2617 52.7359 31.2617 54.0577Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_514_140551"
        x1="233.849"
        y1="117.252"
        x2="95.485"
        y2="-33.2689"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE3FE" />
        <stop offset="1" stopColor="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_514_140551"
        x1="130.65"
        y1="-93.1619"
        x2="127.428"
        y2="-49.144"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE3FE" />
        <stop offset="1" stopColor="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_514_140551"
        x1="113.283"
        y1="70.9077"
        x2="113.283"
        y2="6.09469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53EAC9" />
        <stop offset="0.996377" stopColor="#45AED8" />
        <stop offset="1" stopColor="#45AED8" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_514_140551"
        x1="107.423"
        y1="103.835"
        x2="105.235"
        y2="31.6739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset="1" stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_514_140551"
        x1="104.938"
        y1="33.4649"
        x2="118.985"
        y2="33.4649"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_514_140551"
        x1="116.197"
        y1="101.788"
        x2="113.814"
        y2="23.1743"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset="1" stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_514_140551"
        x1="61.9409"
        y1="57.889"
        x2="90.1338"
        y2="57.889"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53EAC9" />
        <stop offset="0.996377" stopColor="#45AED8" />
        <stop offset="1" stopColor="#45AED8" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_514_140551"
        x1="55.9425"
        y1="57.0717"
        x2="76.6111"
        y2="57.0717"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_514_140551"
        x1="68.9931"
        y1="14.6708"
        x2="94.4833"
        y2="14.6708"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6673FD" />
        <stop offset="1" stopColor="#5C69EA" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_514_140551"
        x1="56.5206"
        y1="69.2978"
        x2="78.0377"
        y2="69.2978"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_514_140551"
        x1="197.388"
        y1="113.478"
        x2="197.756"
        y2="102.328"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset="1" stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_514_140551"
        x1="194.491"
        y1="85.7379"
        x2="195.713"
        y2="96.4873"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset="1" stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_514_140551"
        x1="167.986"
        y1="120.885"
        x2="167.646"
        y2="110.597"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset="1" stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_514_140551"
        x1="169.068"
        y1="89.8267"
        x2="170.133"
        y2="99.1978"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset="1" stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_514_140551"
        x1="249.154"
        y1="16.5342"
        x2="220.594"
        y2="43.3782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_514_140551"
        x1="191.049"
        y1="19.0502"
        x2="185.557"
        y2="19.0502"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset="1" stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_514_140551"
        x1="187.341"
        y1="10.4861"
        x2="185.117"
        y2="23.6761"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset="1" stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_514_140551"
        x1="191.823"
        y1="15.5"
        x2="185.151"
        y2="8.35582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_514_140551"
        x1="189.743"
        y1="24.6368"
        x2="190.14"
        y2="15.3565"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset="1" stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_514_140551"
        x1="152.982"
        y1="16.3602"
        x2="150.209"
        y2="25.5421"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset="1" stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_514_140551"
        x1="193.62"
        y1="45.2079"
        x2="203.529"
        y2="53.7385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset="1" stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_514_140551"
        x1="31.3496"
        y1="74.9683"
        x2="42.7107"
        y2="74.9683"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_514_140551"
        x1="33.4701"
        y1="53.6183"
        x2="30.1362"
        y2="62.0472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_514_140551"
        x1="19.0093"
        y1="109.414"
        x2="16.4297"
        y2="109.414"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_514_140551"
        x1="29.9094"
        y1="119.507"
        x2="26.2546"
        y2="76.4548"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_514_140551"
        x1="30.9942"
        y1="108.947"
        x2="26.8203"
        y2="108.947"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_514_140551"
        x1="22.4422"
        y1="120.149"
        x2="18.7864"
        y2="77.0854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_514_140551"
        x1="31.9917"
        y1="74.3161"
        x2="30.2236"
        y2="61.2793"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_514_140551"
        x1="35.9251"
        y1="63.7764"
        x2="29.1918"
        y2="51.6989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_514_140551"
        x1="35.236"
        y1="51.6391"
        x2="31.7991"
        y2="60.3285"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset="1" stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_514_140551"
        x1="33.2813"
        y1="66.7455"
        x2="26.7811"
        y2="55.0862"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_514_140551"
        x1="25.7656"
        y1="77.0548"
        x2="40.5286"
        y2="77.0548"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_514_140551"
        x1="35.9454"
        y1="77.5782"
        x2="37.238"
        y2="77.5782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A22B25" />
        <stop offset="1" stopColor="#C0423C" />
      </linearGradient>
    </defs>
  </svg>
);

export default Empty;
